import { blogCategoryListCountWidgetStyles as styles } from "@solveindustrial/Widgets/VerndaleBox/BlogCategory/BlogCategoryListCountWidget";
import { css } from "styled-components";

styles.countText = {
    ...styles.countText,
    size: 18,
};
